import { render } from "./Upload.vue?vue&type=template&id=3664b14c&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=3664b14c&scoped=true&lang=css"

import exportComponent from "/Users/pmattern/Documents/3 - GIT/studio-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3664b14c"]])

export default __exports__